import log, {INTEGRATION_MODE} from "../cfg";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

export const COGNITO_SSO_TOKEN: string = 'EXP_API_TKN';
export const VCAP_MPM_ID: string = 'VCAP_MPM_ID';
export const VCAP_CLUB_CODE: string = 'VCAP_CLUB_CODE';
export const OWNER_NUMBER: string = 'OWNER_NUMBER';
export const SYSTEM_INTEGRATION_MODE: string = 'SYSTEM_INTEGRATION_MODE';
export const OWNER_NAME: string = 'OWNER_NAME';
export const X_CORRELATION_ID: string = 'X_CORRELATION_ID';
export const MPM_ID: string = 'MPM_ID';
export const VCAP_CONTRACT_TYPES: string = 'VCAP_CONTRACT_TYPES';

let promiseTimeout;

export default promiseTimeout = (ms: number, desc: string, promise: Promise<any>) => {

    // Create a promise that rejects in <ms> milliseconds
    let timeout = new Promise((resolve, reject) => {
        let id = setTimeout(() => {
            clearTimeout(id);
            reject({message: `${desc} timed out in ${ms} ms.`});
        }, ms)
    })

    // Returns a race between our timeout and the passed in promise
    return Promise.race([
        promise,
        timeout
    ])
}

export function handleError(error: any, apiUrl: string) {
    const apiError = "An error occurred, please try again by refreshing your screen or contact us for assistance.";
    let err = {
        message: apiError,
        code: -1,
        errorCode: "",
        errorObject: {}
    };

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // log.error(`${apiUrl} call failed; status code=${error.response.status}`);
        // log.error(`failed response data \n: ${JSON.stringify(error.response.data)}`);
        // err.message = (error.response.data.message ? error.response.data.message : error.response.data.error);
        err.message = apiError;
        err.code = (error.response.status ? error.response.status : -1);
        err.errorCode = (error.response.data.errorCode ? error.response.data.errorCode : "");
        err.errorObject = error.response.data.errorObject || {};
    } else if (error.request) {
        // The request was made but no response was received
        // err.message = 'Bad request. Check logs for details';
        err.message = apiError;
    } else {
        // Something happened in setting up the request that triggered an Error
        log.error(`Error: ${error.message}`);
        // err.message = error.message;
        err.message = apiError;
    }
    return Promise.reject(err);
}

//in case of 401 error (Unauthorized access or Invalid/Expired token) we simulate clicking the logout
// button on the VCAP website page, if the button is found on the page of course
export function handle401Error(error: any): boolean {
    if (error.code && error.code === 401) {
        const logOutElms = document.querySelectorAll("a[href='/logoff.jsp?action=noAction']");
        if (logOutElms && logOutElms.length > 0) {
            (logOutElms[0] as HTMLElement).click();
            return true;
        }
    }
    return false;
}

function parseToken(token: string) {
    let userFromToken = null;

    if (token) {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        userFromToken = JSON.parse(window.atob(base64));
        log.debug(`Current user -> ${JSON.stringify(userFromToken)}`);
    }

    return userFromToken;
}

export function isUserAuthenticated(): boolean {
    let flag = false;
    const token = sessionStorage.read(COGNITO_SSO_TOKEN);
    let userFromToken = parseToken(token);
    if (userFromToken) {
        const now = new Date();
        //check if the token is not expired
        if (now.getTime() <= new Date(userFromToken.exp * 1000).getTime()) {
            flag = true;
        }
    }
    return flag;
}

export function isUserChanged(newToken: string | null): boolean {
    let flag = false;
    const token = sessionStorage.read(COGNITO_SSO_TOKEN);
    let userFromPersistedToken = parseToken(token);
    if (userFromPersistedToken && newToken) {
        let userFromNewToken = parseToken(newToken);
        if (userFromNewToken) {
            if (userFromPersistedToken.username !== userFromNewToken.username) {
                return true;
            }
        }
    }
    return flag;
}
